import { render, staticRenderFns } from "./PricePreSaleCard.vue?vue&type=template&id=cb87926e&scoped=true&"
import script from "./PricePreSaleCard.vue?vue&type=script&lang=js&"
export * from "./PricePreSaleCard.vue?vue&type=script&lang=js&"
import style0 from "./PricePreSaleCard.vue?vue&type=style&index=0&id=cb87926e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb87926e",
  null
  
)

export default component.exports